import { jsxs, jsx } from "react/jsx-runtime";
import "classnames";
import { Modifier, EditorState } from "draft-js";
import { useState, useRef, useEffect } from "react";
import "react-draft-wysiwyg";
/* empty css                       */
const Bold = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.8747%204.68652C15.8001%204.68652%2017.3747%206.18956%2017.3747%208.06152C17.3747%209.12732%2016.8643%2010.0735%2016.0693%2010.6908C17.4052%2011.5253%2018.2913%2012.9722%2018.2913%2014.624C18.2913%2017.2209%2016.1011%2019.3115%2013.4163%2019.3115L9.30653%2019.3125C9.30148%2019.3126%209.29642%2019.3127%209.29134%2019.3127L9.27601%2019.3115H7.45801C7.04379%2019.3115%206.70801%2018.9757%206.70801%2018.5615C6.70801%2018.1473%207.04379%2017.8115%207.45801%2017.8115H8.54101V6.18552L7.45801%206.18652C7.04379%206.18652%206.70801%205.85074%206.70801%205.43652C6.70801%205.02231%207.04379%204.68652%207.45801%204.68652H13.8747ZM13.4274%2011.4365L13.4163%2011.4377L10.041%2011.4375V17.8115H13.4163C15.2879%2017.8115%2016.7913%2016.3764%2016.7913%2014.624C16.7913%2012.8751%2015.2938%2011.4422%2013.4274%2011.4365ZM13.8747%206.18652L10.041%206.18552V9.93752L13.3987%209.93668C13.4046%209.93658%2013.4104%209.93652%2013.4163%209.93652H13.8747C14.9868%209.93652%2015.8747%209.08905%2015.8747%208.06152C15.8747%207.034%2014.9868%206.18652%2013.8747%206.18652Z'%20fill='%23696969'/%3e%3c/svg%3e";
const Italic = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.5625%204.6875C18.9767%204.6875%2019.3125%205.02329%2019.3125%205.4375C19.3125%205.85171%2018.9767%206.1875%2018.5625%206.1875L15.9495%206.18735L9.7495%2017.8124L11.5625%2017.8125C11.9767%2017.8125%2012.3125%2018.1483%2012.3125%2018.5625C12.3125%2018.9767%2011.9767%2019.3125%2011.5625%2019.3125H5.4375C5.02329%2019.3125%204.6875%2018.9767%204.6875%2018.5625C4.6875%2018.1483%205.02329%2017.8125%205.4375%2017.8125L8.0495%2017.8124L14.2495%206.18735L12.4375%206.1875C12.0233%206.1875%2011.6875%205.85171%2011.6875%205.4375C11.6875%205.02329%2012.0233%204.6875%2012.4375%204.6875H18.5625Z'%20fill='%23696969'/%3e%3c/svg%3e";
const Underline = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.5625%2017.8127C18.9767%2017.8127%2019.3125%2018.1485%2019.3125%2018.5627C19.3125%2018.9769%2018.9767%2019.3127%2018.5625%2019.3127H5.4375C5.02329%2019.3127%204.6875%2018.9769%204.6875%2018.5627C4.6875%2018.1485%205.02329%2017.8127%205.4375%2017.8127H18.5625ZM15.9375%204.68652L15.9545%204.68752L16.8125%204.68769C17.2267%204.68769%2017.5625%205.02348%2017.5625%205.43769C17.5625%205.8519%2017.2267%206.18769%2016.8125%206.18769L16.6875%206.18752V12.0002C16.6875%2014.589%2014.5888%2016.6877%2012%2016.6877C9.41117%2016.6877%207.3125%2014.589%207.3125%2012.0002L7.3115%206.18752L7.1875%206.18769C6.77329%206.18769%206.4375%205.8519%206.4375%205.43769C6.4375%205.02348%206.77329%204.68769%207.1875%204.68769L8.04512%204.68672C8.0509%204.68659%208.05669%204.68652%208.0625%204.68652L8.0785%204.68752L8.9375%204.68769C9.35171%204.68769%209.6875%205.02348%209.6875%205.43769C9.6875%205.8519%209.35171%206.18769%208.9375%206.18769L8.8115%206.18752L8.8125%2012.0002C8.8125%2013.7606%2010.2396%2015.1877%2012%2015.1877C13.7604%2015.1877%2015.1875%2013.7606%2015.1875%2012.0002V6.18752L15.0625%206.18769C14.6483%206.18769%2014.3125%205.8519%2014.3125%205.43769C14.3125%205.02348%2014.6483%204.68769%2015.0625%204.68769L15.9203%204.68672C15.926%204.68659%2015.9317%204.68652%2015.9375%204.68652Z'%20fill='%23696969'/%3e%3c/svg%3e";
const Ordered = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.73222%2014.3668C7.59914%2014.599%208.11373%2015.4899%207.88158%2016.3569C7.83769%2016.5208%207.76965%2016.6732%207.68191%2016.8107C7.84381%2017.0632%207.93775%2017.3635%207.9379%2017.6858C7.93831%2018.5833%207.21109%2019.3111%206.31363%2019.3115C5.58279%2019.3119%204.94164%2018.8242%204.74674%2018.1199C4.63628%2017.7207%204.87036%2017.3075%205.26957%2017.197C5.40088%2017.1607%205.5337%2017.1616%205.65676%2017.1935C5.53253%2016.9635%205.53121%2016.6682%205.65285%2016.4368C5.53203%2016.4679%205.40177%2016.4692%205.27267%2016.4347C4.87255%2016.3275%204.63505%2015.9163%204.74219%2015.5162C4.97434%2014.6493%205.86531%2014.1347%206.73222%2014.3668ZM18.5625%2016.9377C18.9767%2016.9377%2019.3125%2017.2735%2019.3125%2017.6877C19.3125%2018.1019%2018.9767%2018.4377%2018.5625%2018.4377H9.8125C9.39829%2018.4377%209.0625%2018.1019%209.0625%2017.6877C9.0625%2017.2735%209.39829%2016.9377%209.8125%2016.9377H18.5625ZM6.3125%209.93652C7.20996%209.93652%207.9375%2010.6641%207.9375%2011.5613C7.93764%2011.9617%207.81745%2012.3517%207.59438%2012.6814C7.80086%2012.815%207.9375%2013.0473%207.9375%2013.3115C7.9375%2013.7257%207.60171%2014.0615%207.1875%2014.0615H5.4375C4.69289%2014.0615%204.40333%2013.0937%205.02559%2012.6848L5.63245%2012.2859C5.57028%2012.3026%205.50493%2012.3115%205.4375%2012.3115C5.02329%2012.3115%204.6875%2011.9757%204.6875%2011.5615C4.6875%2010.6641%205.41504%209.93652%206.3125%209.93652ZM18.5625%2011.6877C18.9767%2011.6877%2019.3125%2012.0235%2019.3125%2012.4377C19.3125%2012.8519%2018.9767%2013.1877%2018.5625%2013.1877H9.8125C9.39829%2013.1877%209.0625%2012.8519%209.0625%2012.4377C9.0625%2012.0235%209.39829%2011.6877%209.8125%2011.6877H18.5625ZM6.3125%2011.4365C6.24346%2011.4365%206.1875%2011.4925%206.1875%2011.5615C6.1875%2011.7379%206.12661%2011.9001%206.0247%2012.0281L6.3796%2011.7949C6.41743%2011.7235%206.43753%2011.6434%206.4375%2011.5615C6.4375%2011.4925%206.38154%2011.4365%206.3125%2011.4365ZM5.875%204.68652C6.53084%204.68652%207.0625%205.21819%207.0625%205.87402L7.06213%208.18752L7.1875%208.18769C7.60171%208.18769%207.9375%208.52348%207.9375%208.93769C7.9375%209.3519%207.60171%209.68769%207.1875%209.68769H5.4375C5.02329%209.68769%204.6875%209.3519%204.6875%208.93769C4.6875%208.52348%205.02329%208.18769%205.4375%208.18769L5.56213%208.18752L5.5625%206.18652H5.4375C5.02329%206.18652%204.6875%205.85074%204.6875%205.43652C4.6875%205.02231%205.02329%204.68652%205.4375%204.68652H5.875ZM18.5625%206.43769C18.9767%206.43769%2019.3125%206.77348%2019.3125%207.18769C19.3125%207.6019%2018.9767%207.93769%2018.5625%207.93769H9.8125C9.39829%207.93769%209.0625%207.6019%209.0625%207.18769C9.0625%206.77348%209.39829%206.43769%209.8125%206.43769H18.5625Z'%20fill='%23696969'/%3e%3c/svg%3e";
const Unordered = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.20841%2015.7906C9.01386%2016.5961%209.01386%2017.902%208.20841%2018.7074C7.40295%2019.5129%206.09705%2019.5129%205.29159%2018.7074C4.48614%2017.902%204.48614%2016.5961%205.29159%2015.7906C6.09705%2014.9852%207.40295%2014.9852%208.20841%2015.7906ZM18.5625%2016.9377C18.9767%2016.9377%2019.3125%2017.2735%2019.3125%2017.6877C19.3125%2018.1019%2018.9767%2018.4377%2018.5625%2018.4377H9.8125C9.39829%2018.4377%209.0625%2018.1019%209.0625%2017.6877C9.0625%2017.2735%209.39829%2016.9377%209.8125%2016.9377H18.5625ZM6.35225%2016.8513C6.13258%2017.0709%206.13258%2017.4271%206.35225%2017.6468C6.57192%2017.8664%206.92808%2017.8664%207.14775%2017.6468C7.36742%2017.4271%207.36742%2017.0709%207.14775%2016.8513C6.92808%2016.6316%206.57192%2016.6316%206.35225%2016.8513ZM8.20841%2010.5406C9.01386%2011.3461%209.01386%2012.652%208.20841%2013.4574C7.40295%2014.2629%206.09705%2014.2629%205.29159%2013.4574C4.48614%2012.652%204.48614%2011.3461%205.29159%2010.5406C6.09705%209.73515%207.40295%209.73515%208.20841%2010.5406ZM18.5625%2011.6877C18.9767%2011.6877%2019.3125%2012.0235%2019.3125%2012.4377C19.3125%2012.8519%2018.9767%2013.1877%2018.5625%2013.1877H9.8125C9.39829%2013.1877%209.0625%2012.8519%209.0625%2012.4377C9.0625%2012.0235%209.39829%2011.6877%209.8125%2011.6877H18.5625ZM6.35225%2011.6013C6.13258%2011.8209%206.13258%2012.1771%206.35225%2012.3968C6.57192%2012.6164%206.92808%2012.6164%207.14775%2012.3968C7.36742%2012.1771%207.36742%2011.8209%207.14775%2011.6013C6.92808%2011.3816%206.57192%2011.3816%206.35225%2011.6013ZM8.20841%205.29062C9.01386%206.09607%209.01386%207.40197%208.20841%208.20743C7.40295%209.01289%206.09705%209.01289%205.29159%208.20743C4.48614%207.40197%204.48614%206.09607%205.29159%205.29062C6.09705%204.48516%207.40295%204.48516%208.20841%205.29062ZM18.5625%206.43769C18.9767%206.43769%2019.3125%206.77348%2019.3125%207.18769C19.3125%207.6019%2018.9767%207.93769%2018.5625%207.93769H9.8125C9.39829%207.93769%209.0625%207.6019%209.0625%207.18769C9.0625%206.77348%209.39829%206.43769%209.8125%206.43769H18.5625ZM6.35225%206.35128C6.13258%206.57095%206.13258%206.9271%206.35225%207.14677C6.57192%207.36644%206.92808%207.36644%207.14775%207.14677C7.36742%206.9271%207.36742%206.57095%207.14775%206.35128C6.92808%206.13161%206.57192%206.13161%206.35225%206.35128Z'%20fill='%23696969'/%3e%3c/svg%3e";
const Emoji$1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M17.1707%206.82928C20.0265%209.68499%2020.0265%2014.315%2017.1707%2017.1707C14.315%2020.0264%209.68502%2020.0264%206.82931%2017.1707C3.9736%2014.315%203.9736%209.68499%206.82931%206.82928C9.68502%203.97357%2014.315%203.97357%2017.1707%206.82928ZM7.88997%207.88994C5.62005%2010.1599%205.62005%2013.8401%207.88997%2016.1101C10.1599%2018.38%2013.8402%2018.38%2016.1101%2016.1101C18.38%2013.8401%2018.38%2010.1599%2016.1101%207.88994C13.8402%205.62002%2010.1599%205.62002%207.88997%207.88994ZM15.2419%2013.0625C14.8242%2013.8976%2014.0969%2014.545%2013.2057%2014.8593C11.4617%2015.4744%209.56211%2014.676%208.75761%2013.0625H15.2419ZM9%209C9.55229%209%2010%209.44772%2010%2010C10%2010.5523%209.55229%2011%209%2011C8.44772%2011%208%2010.5523%208%2010C8%209.44772%208.44772%209%209%209ZM15%209C15.5523%209%2016%209.44772%2016%2010C16%2010.5523%2015.5523%2011%2015%2011C14.4477%2011%2014%2010.5523%2014%2010C14%209.44772%2014.4477%209%2015%209Z'%20fill='%23696969'/%3e%3c/svg%3e";
const Hyperlink = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15.9375%209.25C17.7935%209.25%2019.3125%2010.6967%2019.3125%2012.5C19.3125%2014.3033%2017.7935%2015.75%2015.9375%2015.75H15.061C14.1123%2015.7481%2013.207%2015.3599%2012.5707%2014.6786C12.288%2014.3758%2012.3042%2013.9012%2012.6069%2013.6185C12.9097%2013.3358%2013.3843%2013.352%2013.667%2013.6548C14.0182%2014.0308%2014.5268%2014.2489%2015.0625%2014.25H15.9375C16.981%2014.25%2017.8125%2013.4581%2017.8125%2012.5C17.8125%2011.5419%2016.981%2010.75%2015.9375%2010.75H15.0638C14.5267%2010.7509%2014.0181%2010.969%2013.6671%2011.3451C13.3845%2011.6479%2012.9099%2011.6643%2012.6071%2011.3816C12.3043%2011.099%2012.2879%2010.6244%2012.5705%2010.3216C13.2068%209.63992%2014.1123%209.25166%2015.0625%209.25H15.9375ZM8.93889%209.25C9.88768%209.25175%2010.7932%209.63998%2011.4294%2010.3215C11.7121%2010.6243%2011.6957%2011.0989%2011.393%2011.3816C11.0902%2011.6642%2010.6156%2011.6479%2010.3329%2011.3451C9.98187%2010.9691%209.47324%2010.751%208.9375%2010.75H8.0625C7.019%2010.75%206.1875%2011.5419%206.1875%2012.5C6.1875%2013.4581%207.019%2014.25%208.0625%2014.25H8.93583C9.47309%2014.2488%209.98182%2014.0307%2010.3331%2013.6547C10.6159%2013.352%2011.0905%2013.3359%2011.3932%2013.6186C11.6958%2013.9014%2011.712%2014.376%2011.4292%2014.6787C10.7929%2015.3598%209.8877%2015.7479%208.9375%2015.75H8.0625C6.2065%2015.75%204.6875%2014.3033%204.6875%2012.5C4.6875%2010.6967%206.2065%209.25%208.0625%209.25H8.93889ZM15.0625%2011.75C15.4767%2011.75%2015.8125%2012.0858%2015.8125%2012.5C15.8125%2012.9142%2015.4767%2013.25%2015.0625%2013.25H8.9375C8.52329%2013.25%208.1875%2012.9142%208.1875%2012.5C8.1875%2012.0858%208.52329%2011.75%208.9375%2011.75H15.0625Z'%20fill='%23696969'/%3e%3c/svg%3e";
const Attachment = "data:image/svg+xml,%3csvg%20width='10'%20height='16'%20viewBox='0%200%2010%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.60686%2010.1869C9.60686%2010.6011%209.27108%2010.9369%208.85686%2010.9369C8.44265%2010.9369%208.10686%2010.6011%208.10686%2010.1869V5.375C8.10686%203.61117%206.71225%202.1875%204.99972%202.1875C3.2872%202.1875%201.89258%203.61117%201.89258%205.375V11.9375C1.89258%2012.9765%202.71156%2013.8125%203.71401%2013.8125C4.71645%2013.8125%205.53544%2012.9765%205.53544%2011.9375V5.375C5.53544%205.06092%205.29209%204.8125%204.99972%204.8125C4.70736%204.8125%204.46401%205.06092%204.46401%205.375V11.0625C4.46401%2011.4767%204.12822%2011.8125%203.71401%2011.8125C3.29979%2011.8125%202.96401%2011.4767%202.96401%2011.0625V5.375C2.96401%204.23934%203.87193%203.3125%204.99972%203.3125C6.12752%203.3125%207.03544%204.23934%207.03544%205.375V11.9375C7.03544%2013.798%205.55188%2015.3125%203.71401%2015.3125C1.87613%2015.3125%200.392578%2013.798%200.392578%2011.9375V5.375C0.392578%202.78959%202.45177%200.6875%204.99972%200.6875C7.54768%200.6875%209.60686%202.78959%209.60686%205.375V10.1869Z'%20fill='%23696969'/%3e%3c/svg%3e";
const images = {
  // Inline
  Bold,
  Italic,
  Underline,
  // List
  Ordered,
  Unordered,
  Emoji: Emoji$1,
  Hyperlink,
  Attachment
};
const onSelectEmoji = (emoji, state, setState) => {
  const contentState = state.getCurrentContent();
  const selectionState = state.getSelection();
  const newContentState = Modifier.insertText(contentState, selectionState, emoji);
  const newEditorState = EditorState.push(state, newContentState, "insert-characters");
  setState(newEditorState);
};
const EmojiPicker = ({ onSelectEmoji: onSelectEmoji2, above }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTop, setModalTop] = useState("");
  const [modalLeft, setModalLeft] = useState("");
  const emojiPicker = useRef(null);
  const onSelect = (emoji) => {
    onSelectEmoji2(emoji);
    setModalVisible(false);
  };
  const repositionModal = () => {
    if (emojiPicker.current) {
      const rect = emojiPicker.current.getBoundingClientRect();
      if (rect.left + 240 > window.innerWidth) {
        setModalLeft(`${window.innerWidth - 240}px`);
      } else {
        setModalLeft(`${rect.left}px`);
      }
      if (!above && rect.top + 185 > window.innerHeight) {
        setModalTop(`${window.innerHeight - 185}px`);
      } else if (above) {
        setModalTop(`${rect.bottom - 208}px`);
      } else {
        setModalTop(`${rect.bottom}px`);
      }
    }
  };
  useEffect(() => {
    repositionModal();
  }, [modalVisible]);
  useEffect(() => {
    function closeIfEscapeKeyPressed(e) {
      if (e.key === "Escape") {
        setModalVisible(false);
      }
    }
    repositionModal();
    document.addEventListener("keydown", closeIfEscapeKeyPressed);
    return () => document.removeEventListener("keydown", closeIfEscapeKeyPressed);
  }, []);
  useEffect(() => {
    function closeIfClickOutsidePicker(event) {
      if (emojiPicker.current && !emojiPicker.current.contains(event.target)) {
        setModalVisible(false);
      }
    }
    document.addEventListener("mousedown", closeIfClickOutsidePicker);
    return () => document.removeEventListener("mousedown", closeIfClickOutsidePicker);
  }, [emojiPicker]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "sa-emoji-picker rdw-emoji-wrapper",
      ref: emojiPicker,
      "aria-haspopup": "true",
      title: "Emojis",
      children: [
        /* @__PURE__ */ jsx(
          SelectEmojiButton,
          {
            onClick: () => setModalVisible((isVisible) => !isVisible),
            expanded: modalVisible
          }
        ),
        modalVisible && /* @__PURE__ */ jsx("div", { className: "rdw-emoji-modal", style: { position: "fixed", top: modalTop, left: modalLeft }, children: emojis.map((emoji, i) => /* @__PURE__ */ jsx(
          Emoji,
          {
            i,
            emoji,
            onSelectEmoji: onSelect
          },
          emoji.toString()
        )) })
      ]
    }
  );
};
const SelectEmojiButton = ({ onClick, expanded }) => /* @__PURE__ */ jsx(
  "button",
  {
    type: "button",
    "aria-label": "Select emoji",
    onClick,
    className: "sa-editor-toolbar rdw-option-wrapper select-emoji",
    "aria-expanded": expanded,
    children: /* @__PURE__ */ jsx("img", { src: images.Emoji, alt: "Select emoji" })
  }
);
const Emoji = ({
  emoji,
  onSelectEmoji: onSelectEmoji2,
  i
}) => {
  return /* @__PURE__ */ jsx(
    "button",
    {
      "aria-label": `emoji ${i} ${emoji}`,
      onClick: () => onSelectEmoji2(emoji),
      className: "rdw-emoji-icon",
      style: { border: "none", background: "none" },
      children: emoji
    }
  );
};
const stateToHTMLOptions = {
  entityStyleFn: (entity) => {
    const entityType = entity.getType().toLowerCase();
    if (entityType === "link") {
      const data = entity.getData();
      return {
        element: "a",
        attributes: {
          href: data.url,
          target: "_blank"
          // Force all links to open in a new tab
        }
      };
    }
    return entity;
  }
};
const emojis = [
  "😀",
  "😁",
  "😂",
  "😃",
  "😉",
  "😋",
  "😎",
  "😍",
  "😗",
  "🤗",
  "🤔",
  "😣",
  "😫",
  "😴",
  "😌",
  "🤓",
  "😛",
  "😜",
  "😠",
  "😇",
  "😷",
  "👻",
  "😺",
  "😸",
  "😹",
  "😻",
  "😼",
  "😽",
  "🙀",
  "🙈",
  "🙉",
  "🙊",
  "👼",
  "👮",
  "🕵",
  "💂",
  "👳",
  "🎅",
  "👸",
  "👰",
  "👲",
  "🙍",
  "🙇",
  "🚶",
  "🏃",
  "💃",
  "⛷",
  "🏌",
  "🏄",
  "🚣",
  "🏊",
  "⛹",
  "🏋",
  "🚴",
  "👫",
  "💪",
  "👈",
  "👉",
  "🖖",
  "🤘",
  "🖐",
  "👌",
  "👍",
  "👎",
  "✊",
  "👊",
  "👏",
  "🙌",
  "🙏",
  "🐵",
  "🐶",
  "🐇",
  "🐥",
  "🐸",
  "🐌",
  "🐛",
  "🐜",
  "🐝",
  "🍉",
  "🍄",
  "🍔",
  "🍤",
  "🍨",
  "🍪",
  "🎂",
  "🍰",
  "🍾",
  "🍷",
  "🍸",
  "🍺",
  "🌍",
  "🚑",
  "⏰",
  "🌙",
  "🌝",
  "🌞",
  "⭐",
  "🌟",
  "🌠",
  "🌨",
  "🌩",
  "⛄",
  "🔥",
  "🎄",
  "🎈",
  "🎉",
  "🎊",
  "🎁",
  "🎗",
  "🏀",
  "🏈",
  "🎲",
  "🔇",
  "🔈",
  "📣",
  "🔔",
  "🎵",
  "🎷",
  "💰",
  "🖊",
  "📅",
  "✅",
  "❎",
  "💯",
  "🌶",
  "🥐",
  "🥘",
  "🦞",
  "🦀",
  "🍦",
  "🍼",
  "🍹",
  "🍻",
  "🥂",
  "💍",
  "🏳️‍🌈",
  "📍",
  "🤠",
  "🛩",
  "🏂",
  "🏖",
  "🏝",
  "🌊",
  "🏔",
  "🌅",
  "🚂",
  "🚕",
  "🚗",
  "🚢",
  "🧳",
  "🩴",
  "🏆",
  "⚽",
  "🤿",
  "🧼"
];
export {
  EmojiPicker as E,
  emojis as e,
  images as i,
  onSelectEmoji as o,
  stateToHTMLOptions as s
};
